<template>
  <div id="scroll-to-prod" class="desktop-hidden" ref="component">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'scroll',
  methods: {
    scrollTo() {
      if (window.innerWidth >= 768) {
        const yCoordinate =
          this.$refs.component.getBoundingClientRect().top + window.pageYOffset
        const yOffset = -120
        window.scrollTo({
          top: yCoordinate + yOffset,
          behavior: 'smooth',
        })
      } else {
        this.$refs.component.scrollIntoView({
          block: 'start',
          behavior: 'smooth',
        })
      }
    },
  },
}
</script>

<style>
/* @media only screen and (max-width: 768px) {
} */
</style>
